import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight, Wand2 } from 'lucide-react';
import { api } from '@/lib/api';
import { StyleCard } from '@/components/cards';
import { LoadingState } from '@/components/states';
import { STYLES } from '@/data/styles';

export default function Home() {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState('');
  const [styles, setStyles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/styles')
      .then(({ data }) => setStyles(data && data.length ? data : STYLES))
      .catch(() => setStyles(STYLES))
      .finally(() => setLoading(false));
  }, []);

  const go = () => {
    const q = prompt.trim() ? `?prompt=${encodeURIComponent(prompt.trim())}` : '';
    navigate(`/create${q}`);
  };

  return (
    <div className="space-y-14">
      {/* Hero */}
      <section className="animate-fade-up pt-6 sm:pt-10">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand/10 px-4 py-1.5 font-mono text-xs uppercase tracking-widest text-brand">
            <Sparkles className="h-3.5 w-3.5" /> Le studio de ton imagination
          </span>
          <h1 className="mt-6 font-display text-4xl font-extrabold leading-none tracking-tight text-white sm:text-5xl lg:text-6xl">
            Composons une <span className="text-gradient-orange">chanson</span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground">
            Décris ton idée, choisis un style, et laisse MyMusic IA créer ta musique originale.
          </p>

          <div className="card-surface mt-8 p-3 text-left">
            <textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Décrivez la chanson que vous souhaitez créer..."
              rows={3}
              data-testid="song-prompt-input"
              className="w-full resize-none bg-transparent px-3 py-2 text-base text-white placeholder:text-muted-foreground focus:outline-none"
            />
            <div className="flex items-center justify-between px-1">
              <button className="flex items-center gap-1.5 rounded-full bg-surface-card px-3 py-1.5 text-xs text-muted-foreground hover:text-white"
                      onClick={() => navigate('/create')} data-testid="home-advanced-button">
                <Wand2 className="h-3.5 w-3.5" /> Mode avancé
              </button>
              <button onClick={go} data-testid="home-create-button"
                      className="flex items-center gap-2 rounded-full bg-brand px-6 py-2.5 font-semibold text-black btn-glow transition-transform hover:scale-[1.02]">
                Créer <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Styles */}
      <section>
        <div className="mb-6 flex items-end justify-between">
          <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            Quel son veux-tu créer ?
          </h2>
        </div>
        {loading ? (
          <LoadingState />
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {styles.map((s) => (
              <StyleCard key={s.id} style={s} onClick={() => navigate(`/create?style=${s.slug}`)} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
